import { z } from 'zod/v4';

export const CrmDealContract = z.object({
    default: z.boolean(),
    id: z.number(),
    mandatory: z.boolean(),
    name: z.string(),
    // The API sends a non-array (e.g. null) for attributes without predefined options;
    // normalize to null before validating, mirroring crm-contacts.
    options: z.preprocess((value) => (Array.isArray(value) ? value : null), z.array(z.string()).nullable()),
    order: z.number(),
    status: z.number(),
    type: z.number(),
    pipelineId: z.number(),
});

export const CrmDealCollectionResponseSchema = z.object({
    data: z.array(CrmDealContract),
});

export type CrmDeal = z.infer<typeof CrmDealContract>;
